//import Moment from "moment";

const getCount = (state) => {
	return state.solicitacoes.length;
}

const ultimaAtualizacaoListaSolicitacao = (state) => {
	if (state.ultimaAtualizacaoListaSolicitacao == null) {
		return true;
	}
	else if(!state.solicitacoes)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.solicitacoes.length == 0 ||
			hour - state.ultimaAtualizacaoListaSolicitacao.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaSolicitacao
}